import React from "react";
import { Grid, IconButton } from "@mui/material";
import BurgerMenu from "./BurgerMenu";
import logoText from '../../assets/logotext.png'
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';

export default function MobileNavbar() {
	return (
		<Grid container alignItems='center' justifyContent='space-between'>
			<Grid item xs={2} container justifyContent='left'>
				<BurgerMenu />
			</Grid>
			<Grid item xs={8} container justifyContent='center'>
				<img width="80%" style={{ maxWidth: "200px" }} src={logoText} alt="logo text" />
			</Grid>
			<Grid item xs={2} container justifyContent='right'>
				<IconButton><NotificationsNoneOutlinedIcon fontSize="large" /></IconButton>
			</Grid>
		</Grid>
	);
};